import React, { useEffect, useState } from "react";
import EditVedioModal from "./EditVedioModal";
import DeleteVedioModal from "./DeleteVedioModal";
import { useLocation } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "ckeditor5/ckeditor5.css";
import {
  ListProperties,
  Alignment,
  List,
  Image,
  AutoImage,
  ImageInsert,
  ImageResize, // Add this
  ImageToolbar, // Add this
  ImageStyle, // Add this
  ImageCaption,
  SimpleUploadAdapter,
  Base64UploadAdapter,
} from "ckeditor5";

import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
} from "ckeditor5";
import QuillEditor from "../../QuillEditor";
import VideoPlayer from "../../VideoPlayer";
const initialState = {
  editVedio: false,
  deleteVedio: false,
  episodName: "",
  videosLink: "",
  audioLink: "",
  hostName: "",
  guestName: "",
  duration: "",
  episodeDate: "",
  description: "",
  thumbnail: "",
};
const EpisodeDetail = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { editVedio, deleteVedio } = iState;
  const {
    episodName,
    episod_number,
    hostName,
    videosLink,
    audioLink,
    guestName,
    episodeDate,
    description,
    thumbnail,
  } = iState;
  const { state } = useLocation();

  useEffect(() => {
    if (state) {
      setUpdateState({
        episodName: state?.episodName,
        episod_number: state?.episod_number,
        hostName: state?.hostName,
        videosLink: state?.videosLink,
        audioLink: state?.url || state?.audioLink,
        thumbnail: state?.artwork || state?.image,
        episodeDate: state?.episodeDate,
        description: state?.description,
        guestName: state?.guestName,
      });
    }

    // if (state?.episodeData) {
    //   setUpdateState((prev) => ({
    //    ...prev,
    //     episodName: state?.episodeData?.title,
    //     episod_number: state?.episodeData?.episodeNumber,
    //     hostName: state?.episodeData?.hostName,
    //     videosLink: state?.episodeData?.videosLink,
    //     audioLink: state?.episodeData?.audioLink,
    //   }));
    // } else {
    //   setUpdateState(initialState);
    // }
  }, [state]);
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">View Episode</h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Episode No.</label>
              <input
                type="text"
                className="form-control"
                placeholder="Auto-fill"
                name="episodName"
                value={episod_number}
                disabled
              />
            </div>
            <div className="form-group">
              <label>Episode Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Episode Name"
                name="episodName"
                value={episodName}
                disabled
              />
            </div>
            <div className="form-group">
              <label>Host Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Host Name"
                name="hostName"
                value={hostName}
                disabled
              />
            </div>
            <div className="form-group">
              <label>Guest Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Host Name"
                name="guestName"
                value={guestName}
                disabled
              />
            </div>
            <div className="form-group">
              <label>Episode Date</label>
              <input
                type="date"
                className="form-control"
                placeholder="Enter Host Name"
                name="episodeDate"
                value={episodeDate}
                disabled
              />
            </div>
            <div className="form-group">
              <label>Podcast Description</label>
              {/* <CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: [
                    "undo",
                    "redo",
                    "|",
                    "bold",
                    "italic",
                    "|",
                    "paragraph",
                    "heading1",
                    "heading2",
                    "|",
                    "bulletedList",
                    // "numberedList",
                    "alignment",
                    // "toggleImageCaption",
                    // "imageTextAlternative",
                    // "ckboxImageEdit",
                    // "insertImage",
                    // "imageResize",
                  ],
                  list: {
                    properties: {
                      styles: true,
                      startIndex: true,
                      reversed: true,
                    },
                  },
                  plugins: [
                    List,
                    ListProperties,
                    Bold,
                    Essentials,
                    Italic,
                    Mention,
                    Paragraph,
                    Undo,
                    Alignment,
                    // Image,
                    // AutoImage,
                    // ImageInsert,
                    // ImageResize, // Add this
                    // ImageToolbar, // Add this
                    // ImageStyle, // Add this
                    // ImageCaption,
                    // SimpleUploadAdapter,
                    // Base64UploadAdapter, // Add this
                  ],
                  // image: {
                  //   toolbar: [
                  //     "imageTextAlternative",
                  //     "toggleImageCaption",
                  //     "imageStyle:inline",
                  //     "imageStyle:block",
                  //     "imageStyle:side",
                  //   ],
                  // },
                  // simpleUpload: {
                  //   uploadUrl: "your-server-url-to-handle-image-upload", // Add your upload API here
                  // },
                  mention: {
                    // Mention configuration
                  },
                }}
                name="description"
                data={description || ""}
                disabled
              /> */}
              <QuillEditor
                name="description"
                value={description}
                disable={true}
              />
            </div>
          </div>
          <div className="CommonForm">
            <div className="TitleBox Border">
              <h4
                className="Title"
                style={{
                  background: "none",
                }}
              >
                Upload Thumnail
              </h4>
            </div>

            <div className="UploadBox Image">
              <span
                style={{
                  zIndex: "99",
                }}
              >
                {!thumbnail ? (
                  <img src={require("../../../assets/images/upload.png")} />
                ) : (
                  <>
                    <img
                      src={thumbnail}
                      alt=""
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        mixBlendMode: "darken",
                      }}
                    />
                  </>
                )}
              </span>
            </div>

            {/* <div className="UploadBox">
              <span>
                <img src="images/upload-video.png" />
              </span>
              <p>
                <label>Click to upload</label> or <br /> drag &amp; drop
              </p>
            </div> */}
          </div>
          <div className="TitleBox Border">
            <h4 className="Title">Upload Audio &amp; Video</h4>
          </div>
          <div className="CommonForm" style={{ display: "flex" }}>
            <div>
              <div
                className="UploadBox Image"
                style={{
                  position: "relative",
                  zIndex: 0,
                  border: "aliceblue",
                  backgroundColor: "none",
                }}
              >
                <span>
                  {videosLink ? (
                    <>
                      {/* <video
                        src={videosLink}
                        controls
                        controlsList="nodownload"
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          mixBlendMode: "darken",
                          zIndex: 1, // Make sure the video is above the input
                        }}
                      /> */}
                      <VideoPlayer
                        url={videosLink}
                        divHeight="110px"
                        divStyle={{
                          height: "100%",
                          position: "absolute",
                          top: "0",
                          left: "0",
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          zIndex: 1,
                        }}
                      />
                    </>
                  ) : (
                    <img src={require("../../../assets/images/upload.png")} />
                  )}
                </span>
              </div>
            </div>

            <div>
              <div
                className={
                  audioLink ? "UploadBox ImagesforAudio" : "UploadBox Image"
                }
                style={{
                  position: "relative",
                  zIndex: 0,
                  width: "250px",
                  // border: audioLink ? "none" : "inherit",
                  // background: audioLink ? "none" : "inherit",
                }}
              >
                <span>
                  {audioLink ? (
                    <>
                      <audio
                        src={audioLink}
                        controls
                        style={{
                          position: "absolute",
                          top: "-23px",
                          left: "26px",
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          mixBlendMode: "darken",
                          zIndex: 1, // Make sure the video is above the input
                        }}
                      />
                    </>
                  ) : (
                    <img src={require("../../../assets/images/upload.png")} />
                  )}
                </span>
              </div>
            </div>
          </div>
          {/* <button className="Button Discard">Discard</button>
          <button className="Button" onClick={handleSubmit}>
            Save
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default EpisodeDetail;
